import type { FaireProductEntity } from "../../entity_types/product";

export const plant_dyed_12: FaireProductEntity = {
  token: "plant-dyed-12",
  type: "product",
  name: "Handmade Tie Dye Cotton Napkin",
  brandName: "Korissa",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/7487b134b2a0a7e22a3ab467363e39f9a8d82c9c944c36b1feabdf7348e05f3a.png",
  priceDollars: 15,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/7487b134b2a0a7e22a3ab467363e39f9a8d82c9c944c36b1feabdf7348e05f3a.png",
  weight: 0.2,
  dimensions: {
    width: 12,
    height: 12,
    depth: 0.5,
  },
  description: "Handmade tie dye cotton napkin with natural dyes",
  categoryTokens: ["cat_accessories"],
  tags: [
    "plant-dyed",
    "natural-dye",
    "sustainable-textiles",
    "tie-dye",
    "cotton",
    "napkin",
    "premium",
  ],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
